import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import Home from './pages/Home'
import About from './pages/About'
import TCTSY from './pages/TCTSY'

function App() {
  const { i18n } = useTranslation()

  return (
    <Router>
      <div className="min-h-screen bg-white max-w-[1200px] mx-auto">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/tctsy" element={<TCTSY />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
